import {
  avatarPreviewSchema,
  avatarStatusSchema,
  ownAvatarSchema,
  type AvatarPreview,
  type AvatarStatus,
  type OwnAvatar,
  type OwnAvatarStyle,
} from '@secretario/shared';
import { apiFetch } from './http.js';

export const AVATAR_KEY = ['own-avatar'] as const;

export async function getAvatarStatus(): Promise<AvatarStatus> {
  return avatarStatusSchema.parse(await apiFetch<unknown>('/v1/avatars/me'));
}

export async function previewAvatar(input: {
  style: OwnAvatarStyle;
  photo: string;
  mime: 'image/jpeg';
}): Promise<AvatarPreview> {
  return avatarPreviewSchema.parse(
    await apiFetch<unknown>('/v1/avatars/preview', {
      method: 'POST',
      body: { ...input, consent: true },
    }),
  );
}

export async function confirmAvatar(previewId: string): Promise<OwnAvatar> {
  return ownAvatarSchema.parse(
    await apiFetch<unknown>('/v1/avatars/confirm', { method: 'POST', body: { previewId } }),
  );
}

export function deleteAvatar(): Promise<void> {
  return apiFetch<void>('/v1/avatars/me', { method: 'DELETE' });
}

/**
 * Selfie reduzida no próprio aparelho (lado maior 1024 px, JPEG) antes de sair:
 * menos dados no caminho e nada além do necessário para o desenho.
 */
export async function shrinkPhoto(file: Blob): Promise<string> {
  const bitmap = await createImageBitmap(file, { imageOrientation: 'from-image' });
  const scale = Math.min(1, 1024 / Math.max(bitmap.width, bitmap.height));
  const canvas = document.createElement('canvas');
  canvas.width = Math.round(bitmap.width * scale);
  canvas.height = Math.round(bitmap.height * scale);
  canvas.getContext('2d')!.drawImage(bitmap, 0, 0, canvas.width, canvas.height);
  bitmap.close();
  const blob = await new Promise<Blob>((resolve, reject) =>
    canvas.toBlob((out) => (out ? resolve(out) : reject(new Error('photo'))), 'image/jpeg', 0.86),
  );
  const bytes = new Uint8Array(await blob.arrayBuffer());
  let binary = '';
  for (let index = 0; index < bytes.length; index += 0x8000) {
    binary += String.fromCharCode(...bytes.subarray(index, index + 0x8000));
  }
  return btoa(binary);
}
